import { api } from './api';

export const userService = {
  getAll: () => api.get('/users').then((res) => res.data),
  getById: (id) => api.get(`/users/id/${id}`).then((res) => res.data),
  create: (payload) => api.post('/users', payload).then((res) => res.data),
  update: (id, payload) => api.put(`/users/${id}`, payload).then((res) => res.data),
  delete: (id) => api.delete(`/users/${id}`),
  bulkCreate: (users) => api.post('/users/bulk', { users }).then((res) => res.data),
};
